import { IFavoriteReport } from '@models/favorites/IFavoriteReport';
import { sendNotification } from '@srm/ui/lib/notifications';
import { errorTraceId } from '@srm/core/errors';

const reportSubMenu = (subMenu: IFavoriteReport['subMenu']): string => {
    const name = subMenu?.toLowerCase() ?? '';
    return name === 'reports' ? '' : name;
};

export const favoriteReportKey = (report: IFavoriteReport): string =>
    JSON.stringify([
        reportSubMenu(report.subMenu),
        report.folder,
        report.searchFolder ? '' : report.name,
        report.form ?? '',
        report.searchFolder ?? '',
    ]);

export const favoriteReportParams = (report: IFavoriteReport): Record<string, string> => ({
    folder: report.folder,
    name: report.name,
    ...(report.form ? { form: report.form } : {}),
    ...(report.searchFolder ? { searchFolder: report.searchFolder } : {}),
    ...(reportSubMenu(report.subMenu) ? { subMenu: reportSubMenu(report.subMenu) } : {}),
});

export const favoriteReportUrl = (report: IFavoriteReport): string =>
    `/reports?${new URLSearchParams(favoriteReportParams(report))}`;

export const FAVORITE_REPORT_ERRORS = {
    CHECK_FAILED: 'Не удалось проверить, есть ли отчёт в избранном. Попробуйте ещё раз.',
    ADD_FAILED: 'Не удалось добавить отчёт в избранное. Попробуйте ещё раз.',
    REMOVE_FAILED: 'Не удалось убрать отчёт из избранного. Попробуйте ещё раз.',
} as const;

/**
 * Запросы избранного отчётов идут без общего тоста: на PROD его видят только
 * администраторы, и отказ остался бы незамеченным.
 */
export const notifyFavoriteReportFailure = (error: unknown, message: string) =>
    sendNotification({ message, variant: 'red', traceId: errorTraceId(error) });
